<template>
    <div>
        {{ msg }}
    </div>
</template>

<script>
export default {
    name: "Usage",
    data() {
        return {
            msg: 'Usage Here!',
        }
    },
}
</script>

<style scoped>

</style>
